<template>
	<div id='reportDesk'>
		<!-- <button @click='handleCilck'>click</button> -->
		<div class="reportDesk_header">
			<div class='reportDesk_header_logo'>
				<div class='logo'>
					<img src="/static/v12houtai/log_hz.png" alt="">
				</div>
				<div class='logo_text elCardStyles' @mouseenter="enter('isSetBooksShow')" @mouseleave="leave('isSetBooksShow')">
					<p>企业报告台</p>
					<span class="icon_container">{{accountInfoData}}<i class="el-icon-arrow-down"></i></span>
					<transition name="el-zoom-in-top">
						<set-books v-show="isSetBooksShow" :superTT='superTT'  @JieSuo = 'getMessage' @modify='modify' @ceratSetOfBooks = 'ceratSetOfBooks' ref='setBooks'></set-books>
					</transition>
				</div>
			</div>
			<div class="reportDesk_header_right" style='line-height: .60rem; padding-right: .40rem;cursor: pointer;'  @click='handleCilck'>
				<img src="/static/icon/new_jump.png" alt="" style='display: inline-block;width: .24rem;margin-bottom: 0.03rem;margin-right: .05rem;'>
				<span class="reportDesk_header_get_in">回到记账系统</span>
			</div>
		</div>
		<div class="reportDesk_nav">
			<ul class="reportDesk_nav_ul">
				<li v-for='item in navList' :key='item.icon' @click='handleCilckJump(item)' :class='nowTab==item.path?"active":""'>
					<span :class='item.icon=="yibiaopan"?"reportDesk_nav_img":"reportDesk_nav_img1"'>
						<img :src="'/static/v12houtai/'+item.icon+'.png'" alt="item.name">
					</span>
					{{item.name}}
				</li>
			</ul>
		</div>
		<div  class="reportDesk_content">
			<keep-alive>
				<router-view  :super_messages='super_messages' @super_messages_back='super_messages_back' />
			</keep-alive>
		</div>

		<!-- 创建、修改账套 -->
		<el-dialog
			:title="title"
			:lock-scroll='false'
			:visible.sync='dialogVisible'
			width="700px"
			:show-close='false'
			:close-on-click-modal='false'
			:close-on-press-escape='false'
			>
			<div v-loading="loading">
				<el-form ref='creatForm' :model='form' :rules='rulesForm' :inline='true'>
					<el-form-item label='账套名称：' prop='alias'>
						<el-input class='accountName' size='mini' placeholder='请输入账套名称' v-model='form.alias'></el-input>
					</el-form-item>
					<el-form-item label='会计制度：' prop='type'>
						<el-select v-model='form.type' style='width:178px; ' size='mini' :disabled='changeSend'>
							<el-option v-for = "item in accountingSystem" :value='item.type' :label='item.name' :key='item.id'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label='启用期间：' prop='startYearPeriod'>
						<el-date-picker
							style='width:178px'
							:disabled='changeSend'
						    v-model="dates.startYearPeriod"
						    type="month"
						    @change='handleMouthChange'
						    placeholder="选择月"
						    size='mini'>
						</el-date-picker>
					</el-form-item>
					<div class="creatButton_G">
						<el-button type='warning'  class="creatButton"  @click='handleQuxiao'>取消</el-button>
						<el-button  class="creatButton minButton"  @click='creatAccount'>确认</el-button>
					</div>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import setBooks from '@/components/dialog/setBooks'
	export default {
		components: {
			setBooks
		},
		data(){
			return {
				clickID:'',  // 当前点击账套ID
				title: '',
				loading: false,
				accountingSystem:[],
				changeSend:true,  // 是否禁用
				form:{
					alias:"",
					type: "",
				},
				rulesForm: {
					alias: [{
						required: true, message: '请输入账套名称'
					}],
					type: [{
						required: true, message: '会计制度不能为空！'
					}],
					startYearPeriod: [{
						required: true, message: '启用期间不能为空！'
					}]
				},
				dates:{
					startYearPeriod:''
				},
				dialogVisible: false,   // 创建账套/修改账套
				super_messages: false,
				superTT: false,
				isSetBooksShow: false,  // 是否显示账套
				navList: [
					{name:'仪表盘',path:'/reportDesk/dashboard',icon: 'yibiaopan'},
					{name:'报表',path:'/reportDesk/report_form',icon: 'baobiao'}
				],
				nowTab: '/reportDesk/dashboard',
				//companyNames:'未获取公司名称'
			}
		},
		created() {
			this.getAccountInfo();
			this.getAccountSystem();
		},
		mounted() {
			this.nowTab = this.$route.path;
		},
		computed: {
			accountInfoData () {
				return this.$store.state.accountInfo.accountInfoData.name
			},
		},
		methods: {
			// 创建次账套
			ceratSetOfBooks(bookId) {
				if(bookId) {
					this.clickID = bookId;
					this.dialogVisible = true;
					this.title = '创建账套';
					this.form.alias = '';
					this.changeSend = false;
				}
			},
			// 获取会计制度
			getAccountSystem() {
				this.$http.post('sys/accounting/list' , {}).then(res=>{
					this.accountingSystem = res.data.data;
				})
			},
			// 创建账套
			async creatAccount() {
				if(this.changeSend) {
					let valid = await this.$refs.creatForm.validate();
					if(valid) {
						try{
							this.loading = true;
							this.$http.post('createAccountSet/updateNameByCid',{name:this.form.alias , id: this.clickID}).then(res=>{
								if(res&&res.data.code==1) {
									this.$nextTick(()=>{
										this.$refs.setBooks.getBooks();
										this.getAccountInfo();
									})
									this.dialogVisible = false;
									this.changeSend = false;
									this.$store.commit('IS_FIRST_LOGIN' , false)
									this.$message({
										type: 'success',
										message: res.data.msg,
										showClose: true,
									})
								}
								this.loading = false;
							})
						}catch(e) {
							this.loading = false;
						}finally{

						}
					}
				}else{
					let valid = await this.$refs.creatForm.validate();
					if(valid) {
						try{
							this.loading = true;
							this.$http.post('createAccountSet/UpdateSencondBook',{...this.form,bookId:this.clickID}).then(res=>{
								if(res.data.code==1) {
									this.$nextTick(()=>{
										this.$refs.setBooks.getBooks();
									})
									this.dialogVisible = false;
									this.changeSend = false;
									this.$message({
										type: 'success',
										message: res.data.msg,
										showClose: true,
									})
								}
								this.loading = false;
							})
						}catch(e) {
							this.loading = false;
						}finally{

						}
					}
				}

			},
			// 修改账套名称
			modify(data) {
				this.dialogVisible = true;
				this.changeSend = true;
				this.title = '修改账套';
				this.clickID = data.bookId;
				this.$set(this.form,'alias',data.bookName);
				this.$set(this.form,'startYearPeriod',data.startYearPeriod);
				this.$set(this.dates,'startYearPeriod',data.startYearPeriod);
				 this.$set(this.form,'type',data.accountingSystem);
			},
			handleMouthChange(val) {
				if(val) {
					this.$set(this.form , 'startYearPeriod' , this.$util.formatDate.format(val , 'yyyMM'))
				}
			},
			// 取消
			handleQuxiao() {
				this.dialogVisible = false;
			},
			// 点击账套返回状态值
			super_messages_back(data) {
				this.super_messages = false;
			},
			// 获取当前账套信息
			getAccountInfo () {
				this.$store.dispatch('getAccountInfo')

			},
			// 切换账套
			getMessage(data) {
				sessionStorage.setItem('cid',data.bookId);
				this.getAccountInfo();
				this.$http.post('createAccountSet/changeBook',{}).then((res)=>{
					if(res&& res.data.code == 1) {

					}
				})
				this.isSetBooksShow = false;
				this.super_messages = true;
			},
			enter(val) {
				this.superTT = true;
				this[val] = true;
			},
			leave(val){
				this.superTT = false;
				this[val] = false;
			},
			// 获取公司名字
			// companyName(data) {
			// 	if(data) {
			// 		this.companyNames = data;
			// 	}
			// },
			// 路由跳转
			handleCilckJump(item) {
				this.nowTab = item.path;
				this.$router.push(item.path)
			},
			handleCilck() {
				this.$router.push('/')
			},

		}

	}
</script>
<style lang="less" scoped>
	@import '../assets/css/reportDesk.less';
</style>



// WEBPACK FOOTER //
// src/pages/reportDesk.vue